import { graphql } from 'gatsby';
import parse from 'html-react-parser';

import { LightBox } from '../Lightbox';

type ProductInfoSectionProps = Queries.InfoSectionFragmentFragment;

export const ProductInfoSection = ({ sections }: ProductInfoSectionProps) => (
  <section className='product-accessories'>
    {sections?.map((section) => {
      if (!section) {
        return null;
      }

      return (
        <div className='item' key={section.id}>
          <div className={'description'}>
            {section.title && parse(section.title)}
          </div>
          <div className={'specification'}>
            {section.body?.data && parse(section.body.data.body)}
          </div>
          <div>
            {section.images?.slice(0, 2).map((image) => {
              if (!image) {
                return null;
              }

              return (
                <LightBox
                  src={image.localFile!.publicURL!}
                  alt={image.alternativeText!}
                  key={image.id}
                />
              );
            })}
          </div>
        </div>
      );
    })}
  </section>
);

export const query = graphql`
  fragment InfoSectionFragment on STRAPI__COMPONENT_PRODUCT_INFO_SECTION {
    sections {
      id
      images {
        alternativeText
        id
        localFile {
          publicURL
        }
      }
      title
      body {
        data {
          body
        }
      }
    }
  }

  fragment ProductInfoSectionFragment on STRAPI_PRODUCT {
    info_sections {
      ...InfoSectionFragment
      id
      title
    }
  }
`;
